import clsx from 'clsx';
import { Dispatch, SetStateAction } from 'react';
import { UploadMediaType } from '../../../types';
import { ButtonColor, TextButton, Typography, TypographyType } from '../../shared';

interface ManualUploadCardProps {
  setMediaType: Dispatch<SetStateAction<UploadMediaType | undefined>>;
  className?: string;
  disabled?: boolean;
  disabledTooltip?: string;
}

const ManualUploadCard = ({ setMediaType, disabled, disabledTooltip, className }: ManualUploadCardProps) => {
  const sharedButtonProps = {
    color: ButtonColor.NEUTRAL,
    disabled,
    tooltip: disabledTooltip,
  };

  return (
    <div className={clsx('flex justify-between gap-2 bg-base-200 p-4', className)}>
      <Typography type={TypographyType.H3}>Manual upload</Typography>
      <div className="flex gap-2">
        <TextButton text="Upload file" onClick={() => setMediaType(UploadMediaType.FILE)} {...sharedButtonProps} />
        <TextButton text="Share link" onClick={() => setMediaType(UploadMediaType.LINK)} {...sharedButtonProps} />
      </div>
    </div>
  );
};

export default ManualUploadCard;
